module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAASFJREFUSEvtla1KBGEUhp8XDEbbCm7QsLDBYPACDMJWg1XY4B1oNCjYtIjJ7gVYBMWgxTvwAgwrGAzGDcIrR75ZZHZGZ1YGyxz42jnn+c4P7xENmxrOTyHA9gBYrAH/AG4lveVjpgC294DTGskz12egJylgEysC3AGbwA4wqgg6B1aBFUkB+hFwD2wUOZfBbJfGFFXQAtoZTO9Su0WTnthekvSSb9KfW2S7AxwCu8ATcCDpOgPNDADegRC/fWAeiB3vAnPAQwI9zgoIRY0fL6TER8AlsAycAFupgiugn14tsYv40Pdj4ELS+Hvvba8nUAhjZpUBERwVnEmKNpWa7ZD2qGitqlwPgRtJrxVvwZeb7e2YS/6q/c9NrvPz33wbr+ATntXEGaVnjHsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/bookmark2.png
// module id = Zd06
// module chunks = 1